import React, { useRef } from 'react';
import { SubmitJobSection, JobHeaderSection } from './types';
import { LabelRow, SplitRow, DraftTextField, DraftTextArea } from './primitives';

interface JobDetailEditorProps {
  data:     SubmitJobSection;
  onChange: (v: SubmitJobSection) => void;
}

const JobDetailEditor: React.FC<JobDetailEditorProps> = ({ data, onChange }) => {
  const orig     = useRef(data);
  const origCard = orig.current.content[0]?.headerSection;

  const setHeader = (p: Partial<JobHeaderSection>) =>
    onChange({
      ...data,
      content: data.content.map((c, i) =>
        i === 0 ? { ...c, headerSection: { ...c.headerSection, ...p } } : c
      ),
    });

  const setButton = (label: string) =>
    setHeader({ button: { ...data.content[0]?.headerSection.button, label } });

  if (!origCard) return null;

  return (
    <>
      <LabelRow label="Main content title" />
      <SplitRow currentText={origCard.label}>
        <DraftTextField placeholder="Main content title"
          onChange={v => setHeader({ label: v })} />
      </SplitRow>

      <LabelRow label="Main title" required />
      <SplitRow currentText={origCard.title}>
        <DraftTextField placeholder="Sector title"
          onChange={v => setHeader({ title: v })} />
      </SplitRow>

      <LabelRow label="Description" />
      <SplitRow currentText={origCard.description} multiline>
        <DraftTextArea placeholder="Description" rows={4}
          onChange={v => setHeader({ description: v })} />
      </SplitRow>

      <LabelRow label="Sub description" />
      <SplitRow currentText={origCard.subDescription}>
        <DraftTextField placeholder="Sub description"
          onChange={v => setHeader({ subDescription: v })} />
      </SplitRow>

      <LabelRow label="Button" />
      <SplitRow currentText={origCard.button.label}>
        <DraftTextField placeholder="Text button"
          onChange={v => setButton(v)} />
      </SplitRow>
    </>
  );
};

export default JobDetailEditor;